import { S121gS121m01Component } from './s121g-s121m01.component';

export { S121gModule } from './s121g.module';

export const S121gSubComponentsMap = {
	
};

export const S121gComponentsMap = {
	"s121g-s121m01": S121gS121m01Component
};

export const S121gComponents = [
	S121gS121m01Component
];

